

<ul class=" wm-job-menu  "  >
  <li class="wm-job-loading-section" *ngIf="jobDataLoading && !jobStatusService.jobDataInProgress.length && !jobDataCompleted.length">
    <div class="wm-job-loading-container"><span>{{locale.MESSAGE_LOADING}}</span></div>
  </li>
  <li class="wm-job-error-section" *ngIf="!jobDataLoading && loadJobError">
    <div class="wm-job-error-container">
      <div class="message"> Jobs could not be loaded!</div>
      <div class="action" (click)="retryClick()">Retry</div>
    </div>
  </li>

  <li class="wm-job-section" *ngIf="!jobDataLoading && !loadJobError">

    <div class="wm-job-section-title"   *ngIf="jobDataCompleted.length || jobStatusService.jobDataInProgress.length">{{locale.LABEL_JOBS_IN_PROCESS}}</div>
    <div class="wm-job-section-list">
      <ng-template   *ngIf="jobDataCompleted.length || jobStatusService.jobDataInProgress.length" >
      <div class="wm-no-job" *ngIf="!jobStatusService.jobDataInProgress.length">
        {{locale.LABEL_EMPTY_JOBS}}
      </div>
      </ng-template>
      <div class="wm-job-in-process" *ngFor="let job of jobStatusService.jobDataInProgress ">
        <div class="wmjip-container">
          <div class="wmjip-content">
            <div class="wmjip-title">{{job.label}} <span *ngIf="job.subLabel">({{job.subLabel}})</span></div>
            <div class="wmjip-progress">
              <div [ngStyle]="job.style"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>


  <li  *ngIf="jobDataCompleted.length || jobStatusService.jobDataInProgress.length" class="divider dropdown-divider"></li>

  <li class="wm-job-section"  *ngIf="!jobDataLoading && !loadJobError">

    <div class="wm-job-section-title" *ngIf="jobDataCompleted.length || jobStatusService.jobDataInProgress.length" >{{locale.LABEL_JOBS_RECENT}}</div>
    <div class="wm-job-section-list">
      <div class="wm-no-job" *ngIf="!jobDataCompleted.length">
          <span aria-hidden="true"><i class="wms wm-icon24 wms-jobs"></i></span>
          <span class="label">{{locale.LABEL_EMPTY_JOBS}}</span>
      </div>
      <div class="wm-job-recent" *ngFor="let job of jobDataCompleted.slice(0,recentJobVisibleCount) ">
        <div class="wmjr-container">
          <div class="wmjr-status" [ngClass]="{'wmjr-status-success': !job.failure,'wmjr-status-error': job.failure}">
            <i  *ngIf="!job.failure"
                class="wms wms-done"></i>
            <i  *ngIf="job.failure"
                class="wms wms-close"></i>
          </div>
          <div class="wmjr-content">
            <div class="wmjr-title">{{job.label}} <span *ngIf="job.subLabel">({{job.subLabel}})</span></div>
            <div *ngIf="job.failure"  class="wmjr-err-metadata wmjr-failed ">{{job.errorMessage}}</div>
            <div class="wmjr-metadata">{{job.completedTime}}</div>
          </div>

          <!--                      Log | wms-document-->

          <div class="wmjr-action" (click)="jobResponseClick(job)" (mouseenter)="onMouseEnterJobResultAction(job.id)" (mouseleave)="onMouseLeaveJobResultAction()">
            <div class="wmjr-tooltip" *ngIf="showhintJob===job.id">
              <span *ngIf="!job.failure && job.outputObject && job.outputObject.outputType==='FILE'">{{locale.LABEL_JOBS_TOOLTIP_DOWNLOAD}}</span>
              <span *ngIf="!job.failure && job.outputObject && job.outputObject.outputType==='REFERENCE_URL'">{{locale.LABEL_JOBS_TOOLTIP_OPEN_LINK}}</span>
              <span *ngIf="job.failure">{{locale.LABEL_JOBS_TOOLTIP_DOWNLOAD_LOG}}</span>
            </div>
            <i *ngIf="!job.failure && job.outputObject && job.outputObject.outputType==='FILE'" class="wms wms-job-download"></i>
            <i *ngIf="!job.failure && job.outputObject && job.outputObject.outputType==='REFERENCE_URL'" class="wms wms-job-link"></i>
            <i *ngIf="job.failure" class="wms wms-job-logs"></i>
          </div>
        </div>
      </div>
      <div class="wmjr-more" *ngIf="jobDataCompleted.length > recentJobVisibleCount" (click)="onMoreClick($event)">
        +{{jobDataCompleted.length-recentJobVisibleCount}} More
      </div>
    </div>
  </li>

  <!--         <li  title="Option 1 | {{locale.LABEL_ZIP_PROJECT}}" *ngFor="let job of jobDataInProgress">-->
  <!--              <a ng-click="" name="wm-header-job-option">-->
  <!--                  <i class="wms wms-template-zip"></i><span class="menu-name"> In Progress | {{job.type}} | {{job.percentage}}</span>-->
  <!--                  <div style="border:1px solid #eee;width:100%;height:5px;">-->
  <!--                      <div [ngStyle]="job.style" style="background:#eee;height:100%">&nbsp;</div>-->
  <!--                  </div>-->
  <!--              </a>-->
  <!--          </li>-->
  <!--          <li><br></li>-->
  <!--          <li title="Option 1 | {{locale.LABEL_ZIP_PROJECT}}" *ngFor="let job of jobDataCompleted">-->
  <!--                  <a ng-click="" name="wm-header-job-option">-->
  <!--                      <i class="wms wms-template-zip"></i><span class="menu-name"> Option 1 Menu | {{job.type}} | {{job.projectId}}</span>-->
  <!--                  </a>-->
  <!--              </li>-->
</ul>

